import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlarmRuleTriggerDto, AlarmRuleTriggerType } from '../../../../../../types/dtos/alarm-rule-trigger.dto';
import { AlarmRuleTriggerFormDto } from '../../../../../../types/dtos/alarm-rule.dto';
import { BaseRule } from '../../base-rule';

export abstract class BaseRuleTrigger extends BaseRule {
  abstract override getType(): AlarmRuleTriggerType;

  abstract override formToConfig(form: AlarmRuleTriggerFormDto): Record<string, unknown>;

  override createFormGroup(trigger: Omit<AlarmRuleTriggerDto, 'alarm_rule_id'>): FormGroup {
    const triggerForm = new FormGroup({
      id: new FormControl<number | null>(trigger.id ?? null),
      type: new FormControl(trigger.type, Validators.required),
      ...this.getFromControls(),
    });

    triggerForm.patchValue({
      ...this.configToFrom(trigger.config),
    }, {emitEvent: false});

    return triggerForm;
  }
}